import React from 'react';
import { Props } from './types';

const Radio = (
  {
    options,
    name,
    error,
    onChange,
    onBlur,
    containerClass,
    className,
    isMultiple = false,
    noPadding = false,
  }: Props,
  ref: React.Ref<HTMLInputElement> | undefined,
) => (
  <>
    <div className={`flex flex-wrap justify-around ${containerClass}`}>
      {options.map((option, idx) => (
        <div
          className={`${className} flex-1 w-[0px] mr-3 basis-[82px] transition-all duration-300 justify-between ease-in-out  mt-4 last:mr-0 `}
          key={idx}
        >
          <input
            name={name}
            type={isMultiple ? 'checkbox' : 'radio'}
            value={option.value}
            id={`${name}_${idx}`}
            ref={ref}
            className={`input-checked-check h-0 absolute`}
            onChange={onChange}
            onBlur={onBlur}
          />
          <label
            htmlFor={`${name}_${idx}`}
            className={`block py-5 text-lg border font-bold text-center outline-offset-2 bg-white rounded cursor-pointer select-none text-grey-600 label-checked-check ${
              noPadding ? 'px-2' : 'px-6'
            } ${
              error
                ? 'border-error-border  bg-error-border bg-opacity-25 text-error-value'
                : ' border-gray-400'
            }`}
          >
            {option.caption}
          </label>
        </div>
      ))}
    </div>

    <div
      className={`mt-2 h-4 text-base transition-all duration-300 ease-in-out transform ${
        error ? 'inline-block text-error-border opacity-100' : 'opacity-0'
      }`}
    >
      {error}
    </div>
  </>
);

export default React.forwardRef(Radio);
